import apiClient from '@/apis/client';
import { User } from '@/types/user';

export default async function getUserApi(token: string): Promise<User> {
  return apiClient.get<User>('/user', { token });
}
